<template>
  <div
    :class="[
      'bbp-timer',
      (disabledButton || isShowTimerModalFinance) && 'bbp-timer_disabled'
    ]"
    @click.stop="onClick($event)"
  >
    <div
      class="bbp-timer__icon"
      v-html="isActiveShow === row.id ? getIconActive(): getIcon()"
      @mouseenter="onMouseenter($event)"
      @mouseleave="isShowPopupInfo = false"
    />
    <div
      :class="[
        'bbp-timer__text',
        isTextBold && 'bbp-timer__text_bold'
      ]"
    >
      {{value}}
    </div>
    <transition name="bbp-bounce">
      <div
        v-if="isShowPopupInfo && !isShowTimerModal"
        class="bbp-timer-popup"
        :style="positionPopup"
      >
        Start timer
      </div>
    </transition>
    <transition name="bbp-bounce">
      <BBPTimerModal
        v-if="isShowTimerModal === row.id"
        :style="positionPopupModal"
        :row="row"
        :column="column"
        :isShowModal.sync="isShowTimerModal"
        :isSubproject="isSubproject"
        :isHourProject="isHourProject"
      />
    </transition>
  </div>
</template>

<script>
import { TIMER_ICON, STOP_TABLE_ICON } from '@/constants/icons'
import { SIDE_HOURLY, HOURLY } from '@/constants/projectTypes'
import BBPTimerModal from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModal'
import convertSecondsToTime from '@/mixin/convertSecondsToTime'
import { TIMER_STATUS } from '@/constants/timerStatus'
import { REMINDER_STATUS } from '@/constants/recurReminders'
import { get } from 'lodash'

export default {
  name: 'BBPTimer',
  components: {BBPTimerModal},
  props: ['row', 'column'],
  mixins: [convertSecondsToTime],
  data: () => ({
    isShowPopupInfo: false,
    positionPopup: {},
    positionPopupModal: {},
    TIMER_STATUS,
    isActiveShow: false
  }),
  computed: {
    isTextBold () {
      const { project, subTimers = {}, subprojectId, requestProject } = this.activeTimer
      const { status = 0, isSub = false } = subTimers
      const { id } = this.row
      if (isSub) {
        return subprojectId === id && status
      } else {
        return (requestProject || project) === id && status
      }
    },
    value () {
      const { prop } = this.column
      const milliSeconds = get(this.row, prop, '')
      if (milliSeconds === 0) return '00:00:00'
      return this.createTime(milliSeconds)
    },
    status () {
      const { COMPLETED } = TIMER_STATUS
      const { status } = this.column
      const items = get(this.row, status, '')
      if (!items.length) return COMPLETED
      const lastItem = items[items.length - 1]
      const { status: statusLastItem } = lastItem
      return statusLastItem
    },
    isShowTimerModal: {
      get () {
        return this.$store.getters.isShowTimerModal
      },
      set (data) {
        this.$store.dispatch('setShowTimerModal', data)
      }
    },
    isStart: {
      get () {
        return this.$store.getters.isStart
      },
      set (data) {
        this.$store.dispatch('setStart', data)
      }
    },
    isPause: {
      get () {
        return this.$store.getters.isPause
      },
      set (data) {
        this.$store.dispatch('setPause', data)
      }
    },
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    disabledButton () {
      const { project, requestProject, subprojectId, subTimers = {} } = this.activeTimer
      const { status = 4, isSub = false } = subTimers
      if (status === TIMER_STATUS.SAVED) return false
      const { id } = this.row
      if (isSub) {
        return subprojectId !== id
      } else {
        return (requestProject || project) !== id
      }
    },
    isShowActiveIcon () {
      const { subTimers = {}, subprojectId } = this.activeTimer
      const { status = 0, isSub = false } = subTimers
      const { ACTIVE, PAUSE } = TIMER_STATUS
      const currentStatus = (status === ACTIVE) || (status === PAUSE)
      return currentStatus && this.isActiveShow === (isSub ? subprojectId : this.row.id)
    },
    isShowTimerModalFinance () {
      return this.$store.getters.isShowTimerModalFinance
    },
    isNoClick () {
      const { isNoClick = false } = this.column
      return isNoClick
    },
    instanceStatus () {
      const { instanceStatus } = this.column
      return instanceStatus
    },
    isProjectTimer () {
      return REMINDER_STATUS.PROJECT === this.instanceStatus
    },
    isSubproject () {
      const { projectType = {} } = this.row
      return projectType.id === SIDE_HOURLY.id
    },
    isHourProject () {
      const { projectType = {} } = this.row
      return projectType.id === HOURLY.id
    }
  },
  methods: {
    getIcon (status = this.status) {
      const { PAUSE, ACTIVE, COMPLETED, SAVED } = TIMER_STATUS
      switch (status) {
      case PAUSE:
        return TIMER_ICON()
      case SAVED:
        return TIMER_ICON()
      case ACTIVE:
        return STOP_TABLE_ICON()
      case COMPLETED:
        return TIMER_ICON()
      default:
        return ''
      }
    },
    getIconActive () {
      return this.isShowActiveIcon ? STOP_TABLE_ICON() : TIMER_ICON()
    },
    createTime (milliSeconds) {
      const sec = Math.floor(milliSeconds / 1000)
      return this.convertSecondsToTime(sec, true)
    },
    changeStatusTimer () {
      const { subTimers = {} } = this.activeTimer
      const { status = 0 } = subTimers
      const currentStatus = this.isActiveShow ? status : this.status
      const { PAUSE, ACTIVE } = TIMER_STATUS
      if (currentStatus === PAUSE) {
        this.isStart = false
        this.isPause = false
      } else if (currentStatus === ACTIVE) {
        this.isStart = false
        this.isPause = true
      } else {
        this.isStart = true
        this.isPause = true
      }
    },
    onClick ({target}) {
      if (this.isNoClick) return
      this.$store.dispatch('setShowPanel', false)
      if (this.disabledButton) return
      const { id, parentProjectId } = this.row
      const { subTimers = {}, subprojectId } = this.activeTimer
      const { status = 0 } = subTimers
      this.activeTimer.project = this.isSubproject ? parentProjectId : id
      const subId = this.isSubproject ? id : subprojectId
      this.activeTimer.subprojectId = status ? subId : undefined
      this.changeStatusTimer()
      this.createPositionModal(target)
      this.isShowTimerModal = id
      this.$store.dispatch('setShowTimer', false)
    },
    createPositionModal (target) {
      const { innerHeight, innerWidth } = window
      const heightModal = 452
      const widthModal = 393
      const { top, left, height } = target.getBoundingClientRect()
      const isBottom = (heightModal + top) > innerHeight
      const isRight = left + widthModal > innerWidth
      this.positionPopupModal = {
        position: 'fixed',
        top: isBottom ? undefined : `${top + height + 4}px`,
        bottom: isBottom ? '30px' : undefined,
        left: isRight ? undefined : `${left + 20}px`,
        right: isRight ? `${150}px` : undefined
      }
    },
    onMouseenter ({target}) {
      this.isShowPopupInfo = true
      const { top, left, height } = target.getBoundingClientRect()
      this.positionPopup = {
        position: 'fixed',
        top: `${top + height + 4}px`,
        left: `${left - 25}px`
      }
    },
    setActiveShow () {
      const { project, requestProject, subprojectId, subTimers = {} } = this.activeTimer
      const { isSub = false } = subTimers
      if (this.isProjectTimer) {
        this.isActiveShow = isSub ? subprojectId : project
      } else {
        this.isActiveShow = requestProject
      }
    }
  },
  watch: {
    isPause () {
      this.setActiveShow()
    },
    isStart () {
      this.setActiveShow()
    }
  },
  beforeMount () {
    const { project, requestProject } = this.activeTimer
    this.isActiveShow = this.isProjectTimer ? project : requestProject
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bbp-timer {
    display: grid;
    grid-template-columns: 16px max-content;
    align-items: center;
    grid-gap: 0 6px;
    cursor: pointer;

    &_disabled {
      pointer-events: none;
    }

    &__text {
     font-size: 13px;
      line-height: 17px;
      font-weight: 400;

      &_bold {
        font-weight: 600;
      }
    }

    &__icon {
      display: flex;
      justify-content: center;
      align-items: center;

      &_pause {
        width: 13px;
        height: 13px;
        margin: 0 0 0 2px;
        border-radius: 4px;
        background: $color-denim;
      }
    }
  }

  .bbp-timer-popup {
    position: absolute;
    left: auto;
    top: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    padding: 4px 7px;
    background: rgba($color-black, 0.55);
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    color: $color-white;
    border-radius: 3px;
    z-index: 20;
    text-transform: capitalize;
    cursor: pointer;

    &:before {
      content: '';
      position: absolute;
      left: auto;
      top: -3px;
      display: block;
      width: 0;
      height: 0;
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      border-bottom: 3px solid rgba($color-black, 0.55);;
    }
  }
</style>

<style lang="scss">

  .bbp-timer__icon {

    &_active svg {
      width: 5px;
      height: 5px;
    }

    &_pause svg {
      width: 7px;
      height: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTimer/BBPTimer.vue